
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { GetServerSideProps, NextPage } from 'next'
import useTranslation from 'next-translate/useTranslation'
import { useState } from 'react'

import { getPrivacyPolicy } from '@/api/other/getPrivacyPolicy'
import { getPrivacyPolicyAll } from '@/api/other/getPrivacyPolicyAll'
import BaseLayout from '@/components/layouts/BaseLayout'
import PrivacyDetail from '@/components/PrivacyPolicy/PrivacyDetail'
import PrivacySidebar from '@/components/PrivacyPolicy/PrivacySidebar'
import Navbar from '@/components/ui/Navbar'
import { NAMESPACE_PRIVACY_POLICY } from '@/res/namespaces'
import { ISelectOption } from '@/types/Common'

interface Props {
  privacy_detail: string
  privacy_results: ISelectOption[]
  id: string
}

const PrivacyPolicyPage: NextPage<Props> = ({
  privacy_detail,
  privacy_results,
  id,
}) => {
  const [isSidebarOpened, setIsSidebarOpened] = useState(false)
  const toggleSidebar = () => {
    setIsSidebarOpened((prevState) => !prevState)

    return isSidebarOpened
  }
  const { t } = useTranslation(NAMESPACE_PRIVACY_POLICY)

  return (
    <BaseLayout seoTitle={t('seo_title')} seoDescription={t('seo_description')}>
      <Navbar notShowMenuIcon toggleSidebar={toggleSidebar} />
      <div className="w-full mt-20 grid grid-flow-row auto-rows-auto gap-[20px] md:grid-flow-col md:auto-cols-auto px-4 py-2 small:py-3  small:px-8 ">
        <PrivacySidebar id={Number(id)} privacyResults={privacy_results} />
        <PrivacyDetail privacyDetail={privacy_detail} />
      </div>
    </BaseLayout>
  )
}

 const _getServerSideProps: GetServerSideProps = async () => {
  const res = await getPrivacyPolicy()
  const res2 = await getPrivacyPolicyAll()
  return {
    props: {
      privacy_detail: res.detail,
      privacy_results: res2.results,
      id: res.id,
    },
  }
}

export default PrivacyPolicyPage


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/privacy-policy',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  